import { render, staticRenderFns } from "./customerPoolOverview.vue?vue&type=template&id=5820f566&scoped=true&"
import script from "./customerPoolOverview.vue?vue&type=script&lang=js&"
export * from "./customerPoolOverview.vue?vue&type=script&lang=js&"
import style0 from "./customerPoolOverview.vue?vue&type=style&index=0&id=5820f566&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5820f566",
  null
  
)

export default component.exports